var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100vw"},attrs:{"id":"Projectlist"}},[_c('div',{attrs:{"id":"a06ab78f"}},[_vm._v(" 项目列表 ")]),_c('div',{attrs:{"id":"a6b3f8e0"}},[_c('dal-comp-project',{attrs:{"id":"cmpa6b3f8e0"}})],1),_c('el-pagination',{attrs:{"id":"b2508ed9"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }